export const emTemplate = (
  node: HTMLElement,
) => `<one-text strong>
${node.innerHTML}
</one-text>`;

export default emTemplate;
